export const API_HOST = 'https://icaps-hanteraservice-prod-cloudrun-o52ydzfbsa-ez.a.run.app'; // Replace with your actual host URL
export const REDIRECT_URI = 'https://icaps-hantera.ingka.com';



